import { getEnv } from 'configs/env';
import { Button, CreateAlert, Icon, NumberUtils, Table } from 'modules';
import moment from 'moment';
import React, { FC, useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import * as XLSX from 'xlsx';

import {
  TableFilterInputText,
  TableFilterRangeTimeInput,
} from '../../../components/table-filter-inputs';
import { TableFilterInputSelect } from '../../../components/table-filter-inputs/select';
import { getLocaleKey, translate } from '../../../languages';
import { AdminService } from '../../../services/admin';
import { GameManagementLayout } from '../components';

const CopyToClipboardElement = CopyToClipboard as any;
export const OrdersPage: FC = GameManagementLayout((props: any) => {
  const optionsTimeFilter = [
    { label: 'This Day', value: 'day' },
    { label: 'This Week', value: 'week' },
    { label: 'This Month', value: 'month' },
    { label: 'Custom', value: 'custom' },
  ];

  const [currentData, setCurrentData] = useState(null as any);
  const [isShowTable, setIsShowTable] = useState<boolean>(true);
  const [params, setParams] = useState<any>();
  const [isShowRangeTime, setIsShowRangeTime] = useState<boolean>(false);
  const [forceUpdateTable, setForceUpdateTable] = useState<boolean>();
  const [valueSupplierFilter, setValueSupplierFilter] = useState<any>();
  const [valueEmailFilter, setValueEmailFilter] = useState<any>();
  const [valueGameFilter, setValueGameFilter] = useState<any>();
  const [valueTimeFilter, setValueTimeFilter] = useState<any>();

  const startOfMonth = moment()
    .subtract(1, 'months')
    .startOf('month')
    .format('YYYY-MM-DD HH:mm:ss');
  const endOfDay = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');

  return (
    <div className='page-game-orders-list'>
      <div className='button-container'>
        <Button
          disabled={!currentData}
          label='Export to Excel'
          buttonType='success'
          className='mb15'
          onClick={async () => {
            // const response = await AdminService.getListRequestClaim({
            //     numberOfTransactionsPerPage: 10000,
            //     page: 1,
            //     fromDate: startOfMonth, //'0',
            //     toDate: endOfDay //moment().toISOString()
            // });
            const response = await AdminService.getListGameOrders({
              ...params,
              page: 1,
              pageSize: 100000,
            });
            const data = [
              [
                'Supplier',
                'Created Date',
                'UID',
                'Email',
                'Game',
                'Amount',
                'Result',
              ],
              ...response.data.map((item: any) => {
                const row: any[] = [];
                row.push(item?.supplier ?? '-');
                row.push(
                  new Date(item?.created).toLocaleString(getLocaleKey()) ?? '-',
                );
                row.push(item?.thirdPartyUid ?? '-');
                row.push(item?.email ?? '-');
                row.push(item?.gameType ?? '-');
                row.push(
                  NumberUtils.toFormatNumber(
                    item?.amount,
                    +getEnv('NUMBER_DECIMAL_DISPLAY'),
                  ) ?? '-',
                );
                row.push(
                  item.status == 'LOSE'
                    ? item.profit > 0
                      ? NumberUtils.toFormatNumber(
                          item.amount - item.profit,
                          +getEnv('NUMBER_DECIMAL_DISPLAY'),
                        )
                      : NumberUtils.toFormatNumber(
                          item.amount,
                          +getEnv('NUMBER_DECIMAL_DISPLAY'),
                        )
                    : item.status == 'WIN'
                      ? NumberUtils.toFormatNumber(
                          item.profit - item.amount,
                          +getEnv('NUMBER_DECIMAL_DISPLAY'),
                        )
                      : (NumberUtils.toFormatNumber(
                          item.profit,
                          +getEnv('NUMBER_DECIMAL_DISPLAY'),
                        ) ?? '-'),
                );
                return row;
              }),
            ];

            const ws = XLSX.utils.aoa_to_sheet(data);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'SheetJS');

            const now = new Date();
            XLSX.writeFile(
              wb,
              `Game-Orders-List-${now.toLocaleDateString().replace(/\//g, '-')} ${now
                .toLocaleTimeString()
                .replace(/:/g, '-')}.xlsx`,
              { type: 'binary' },
            );
          }}
        />
        <div className='infor-container'>
          <div className='total-orders'>
            <div className='total-orders__icon'>
              <Icon.TotalOrdersIcon />
            </div>
            <div className='total-orders__content'>
              {new Intl.NumberFormat('en').format(currentData?.count ?? 0)}
              <span className='sub-text'>&nbsp;TOTAL ORDERS</span>
            </div>
          </div>
          <div className='total-user'>
            <div className='total-user__icon'>
              <Icon.UserParticipationIcon />
            </div>
            <div className='total-user__content'>
              {new Intl.NumberFormat('en').format(
                currentData?.totalUserOrder ?? 0,
              )}
              <span className='sub-text'>&nbsp;USERS PARTICIPATION</span>
            </div>
          </div>
          <div className='total-volume'>
            <div className='total-volume__icon'>
              <Icon.TotalVolumeIcon />
            </div>
            <div className='total-volume__content'>
              {currentData?.totalAmount
                ? NumberUtils.toFormatNumber(currentData?.totalAmount, 8)
                : 0}
              <span className='sub-text'>&nbsp;TOTAL VOLUME</span>
            </div>
          </div>
        </div>
        {/* <div>
                    {currentData ? (
                        <div>
                            <p>
                                Total orders:{" "}
                                {NumberUtils.toFormatNumber(currentData.count)}
                            </p>{" "}
                            <p>
                                Total user orders:{" "}
                                {NumberUtils.toFormatNumber(
                                    currentData.totalUserOrder
                                )}{" "}
                            </p>
                            <p>
                                Total volume:{" "}
                                {NumberUtils.toFormatNumber(
                                    currentData.totalAmount,
                                    8
                                )}
                            </p>
                        </div>
                    ) : null}
                </div> */}
      </div>

      {isShowTable && (
        <Table
          hasOrderColumn
          className='overload'
          filters={[
            {
              name: 'Supplier',
              key: 'supplier',
              input: (s) => (
                <TableFilterInputText
                  {...s}
                  value={valueSupplierFilter}
                  onChange={(e) => {
                    setValueSupplierFilter(e?.supplier);
                    s.onChange(e);
                  }}
                />
              ),
              defaultValue: valueSupplierFilter,
            },
            {
              name: 'Email',
              key: 'searchString',
              input: (s) => (
                <TableFilterInputText
                  {...s}
                  value={valueEmailFilter}
                  onChange={(e) => {
                    setValueEmailFilter(e?.searchString);
                    s.onChange(e);
                  }}
                />
              ),
              defaultValue: valueEmailFilter,
            },
            {
              name: 'Game',
              key: 'gameType',
              input: (s) => (
                <TableFilterInputText
                  {...s}
                  value={valueGameFilter}
                  onChange={(e) => {
                    setValueGameFilter(e?.gameType);
                    s.onChange(e);
                  }}
                />
              ),
              defaultValue: valueGameFilter,
            },
            {
              name: 'Time',
              key: 'time',
              input: (s) => (
                <TableFilterInputSelect
                  {...s}
                  options={optionsTimeFilter}
                  value={valueTimeFilter}
                  onChange={(e) => {
                    setValueTimeFilter(e?.time);
                    s.onChange(e);
                    setForceUpdateTable((state) => !state);
                  }}
                  isClearable={true}
                />
              ),
            },
            {
              name: '',
              key: 'created',
              input: (s) =>
                isShowRangeTime ? (
                  <TableFilterRangeTimeInput
                    {...s}
                    fromKey='fromDate'
                    toKey='toDate'
                  />
                ) : null,
            },
          ]}
          structure={[
            {
              name: 'Supplier',
              render: (item) => item?.supplier ?? '-',
            },
            {
              name: 'Created Date',
              render: (item) => moment(item?.created).format('L LT') ?? '-',
            },
            {
              name: 'UID',
              render: (item) => item?.thirdPartyUid ?? '-',
            },
            {
              name: 'Email',
              className: 'email',
              render: (item) => {
                return (
                  <>
                    <span>
                      <CopyToClipboardElement
                        text={item?.email}
                        onCopy={() => {
                          CreateAlert({
                            message: translate('Copied'),
                            type: 'success',
                          });
                        }}
                      >
                        <div className='value'>
                          <span className='email'>{item?.email ?? '-'}</span>
                          <span className='icon'>
                            <Icon.Copy />
                          </span>
                        </div>
                      </CopyToClipboardElement>
                    </span>
                  </>
                );
              },
            },
            {
              name: 'Game',
              render: (item) => item?.gameType ?? '-',
            },
            {
              name: 'Amount',
              render: (item) =>
                NumberUtils.toFormatNumber(item?.amount, 8) ?? '-',
            },
            {
              name: 'Result',
              render: (item: any) => (
                <span
                  className={`status status--${item?.status?.toLowerCase()}`}
                >
                  {item.status == 'LOSE'
                    ? item.profit > 0
                      ? NumberUtils.toFormatNumber(item.amount - item.profit, 8)
                      : NumberUtils.toFormatNumber(item.amount, 8)
                    : item.status == 'WIN'
                      ? NumberUtils.toFormatNumber(item.profit - item.amount, 8)
                      : NumberUtils.toFormatNumber(item.profit, 8)}
                </span>
              ),
            },
          ]}
          fetchData={async (params) => {
            setParams(params);

            if (params?.time === 'day') {
              params['fromDate'] = moment().startOf('day').toISOString();
              params['toDate'] = moment().endOf('day').toISOString();
              setIsShowRangeTime(false);
            }
            if (params?.time === 'week') {
              params['fromDate'] = moment().startOf('isoWeek').toISOString();
              params['toDate'] = moment().endOf('isoWeek').toISOString();
              setIsShowRangeTime(false);
            }
            if (params?.time === 'month') {
              params['fromDate'] = moment().startOf('month').toISOString();
              params['toDate'] = moment().endOf('month').toISOString();
              setIsShowRangeTime(false);
            }

            if (params?.time === '') {
              setIsShowRangeTime(false);
              delete params.fromDate;
              delete params.toDate;
            }

            if (params?.time === 'custom') {
              if (isShowRangeTime === false) {
                delete params.fromDate;
                delete params.toDate;
              }
              setIsShowRangeTime(true);
            }

            return AdminService.getListGameOrders({
              page: params.pageNumber,
              pageSize: params.limit,
              ...params,
            }).then((res: any) => {
              setCurrentData(res);
              return res;
            });
          }}
          forceUpdateTable={forceUpdateTable}
        />
      )}
    </div>
  );
});
